import React, { useState, forwardRef,  useEffect } from 'react';
import { NavLink, useParams, useNavigate} from 'react-router-dom';
import DatosCabezaFamilia from './../DatosCabezaFamilia.jsx';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService.jsx';
import { useAuth } from '../../../Auth/AuthContext.jsx';
import { useForm, Controller } from 'react-hook-form';
import { Row, Col, Card, CardBody } from 'react-bootstrap';
import CustomInput from '../../Utils/CustomInput2';
import * as XLSX from 'xlsx';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
registerLocale('es', es);
setDefaultLocale('es');


export default function MisIndicadores(){
    const navigate = useNavigate();
    const { token, rol, user } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [misIndicadores, setMisIndicadores] = useState([]);
    const [swalProps, setSwalProps] = useState();
    const { control, setValue, watch, formState: { errors }} = useForm();

    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function ConsultarMisIndicadores (data) {
        const url = '/consultas/misindicadores';
        const obj = {
                FechaInicio: data.FechaInicio
            ? data.FechaInicio.toLocaleDateString('en-CA') // yyyy-MM-dd
            : null,
            FechaFin: data.FechaFin
            ? data.FechaFin.toLocaleDateString('en-CA')
            : null,
            usrId: user
        };
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;
            setMisIndicadores(result.detallesAtencion);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }
    useEffect(() => {
        const fechaActual = new Date();
        setValue('FechaInicio', fechaActual);
        setValue('FechaFin', fechaActual);
        
    }, []);
    
    
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Mis indicadores</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                                <li className="breadcrumb-item active"> Mis indicadores</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                    </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="card" style={{ zIndex: 1100, marginTop: '20px', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
                        <div className="card-body">
                            <form
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    const data = {
                                        FechaInicio: watch('FechaInicio'),
                                        FechaFin: watch('FechaFin'),
                                    };
                                    await ConsultarMisIndicadores(data);
                                }}
                            >
                                <Row>
                                    <Col md={3}>
                                        <div className="form-group">
                                            <label htmlFor="FechaInicio">Fecha Inicio</label>&nbsp;
                                            <Controller
                                                control={control}
                                                name="FechaInicio"
                                                render={({ field }) => (
                                                    <DatePicker
                                                        placeholderText="fecha"
                                                        onChange={(date) => field.onChange(date)}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        selected={field.value}
                                                        customInput={<CustomInput onClick={() => {}}/>}
                                                        locale="es"
                                                        dateFormat="yyyy-MM-dd"
                                                        maxDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {errors.FechaInicio && <p style={{color: 'red'}}>Digite fecha Inicio</p>}
                                        </div>                                    
                                    </Col>
                                    <Col md={3}>
                                        <div className="form-group">
                                            <label htmlFor="FechaFin">Fecha Fin</label>&nbsp;
                                            <Controller
                                                control={control}
                                                name="FechaFin"
                                                render={({ field }) => (
                                                    <DatePicker
                                                        placeholderText="fecha"
                                                        onChange={(date) => field.onChange(date)}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        selected={field.value}
                                                        customInput={<CustomInput onClick={() => {}}/>}
                                                        locale="es"
                                                        dateFormat="yyyy-MM-dd"
                                                        maxDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {errors.FechaFin && <p style={{color: 'red'}}>Digite fecha fin</p>}
                                        </div>
                                    </Col>
                                    <Col md={1}>
                                        <button 
                                            type='submit' 
                                            className="btn btn-primary mb-3" 
                                            style={{ width: '100%' }}
                                        >
                                            Consultar <i className="fas fa-arrow-circle-right"/>
                                        </button>
                                    </Col>
                                </Row>
                            </form>
                        </div>
                    </div>
                    {misIndicadores.length > 0 && <Row 
                        xs={1} 
                        sm={2} 
                        md={4} 
                        className="g-3"
                        style={{ zIndex: 1500, marginTop: '20px' }}>
                        <Col md={12}>
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">INFORME DE INDICADORES POR USUARIO</h3>
                                </div>
                                <div className="card-body">
                                    <button
                                        type="button"
                                        className="btn btn-primary mb-3"
                                        onClick={() => {
                                            const headers = ["No", "Entidad", "Ayuda", "Cantidad"];
                                            const rows = misIndicadores.map((indicador, index) => [
                                                index + 1,
                                                indicador.ent_entidad,
                                                indicador.ayu_ayuda,
                                                indicador.cantidad,
                                            ]);
                                            const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
                                            const workbook = XLSX.utils.book_new();
                                            XLSX.utils.book_append_sheet(workbook, worksheet, "MisIndicadores");
                                            XLSX.writeFile(workbook, "misIndicadores.xlsx");
                                        }}
                                    >
                                        Descargar Excel
                                    </button>
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>No</th>
                                                <th>Entidad</th>
                                                <th>Ayuda</th>
                                                <th>Cantidad</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {misIndicadores.length > 0 ? (
                                                misIndicadores.map((indicador, index) => (
                                                    <tr key={indicador.id || `${indicador.ent_entidad}-${indicador.ayu_ayuda}-${index}`}>
                                                        <td>{index + 1}</td>
                                                        <td>{indicador.ent_entidad}</td>
                                                        <td>{indicador.ayu_ayuda}</td>
                                                        <td>{indicador.cantidad}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">
                                                        No hay datos disponibles
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                    </Row>}
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}